import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout';
import classes from "./Leaderboard.module.css";
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import moment from 'moment-timezone';
import { leaderboardApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { removeToken } from '../store/slices/tokenSlice';
import Spinner from '../components/Spinner';
import { useTranslation } from 'react-i18next';

const Leaderboard = () => {
    const [monthYear, setMonthYear] = useState(new Date());
    const { tokenData } = useSelector(state => state?.tokenSlice);
    const [leaderboard, setLeaderboard] = useState([]);
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleMonthYearChange = (e) => {
        setMonthYear(e.value);
    };

    const fetchLeaderboard = async () => {
        try {
            setLoading(true);
            const startDate = moment(monthYear).startOf("month").format("YYYY-MM-DD");
            const endDate = moment(monthYear).endOf("month").format("YYYY-MM-DD");
            const response = await leaderboardApi(startDate, endDate, tokenData);
            console.log(response, 'response...');
            setLeaderboard(response?.data?.result);
            setLoading(false);

        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);

            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error(t('common.tokenExpired'));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || t('common.somethingWentWrong'));
            }
        }
    }

    useEffect(() => {
        fetchLeaderboard();
    }, [monthYear]);

    console.log(monthYear, 'my');

    return (
        <Layout active={3}>
            <div className={classes.date_containers}>
                <div className={classes.date_container}>
                    <Calendar
                        showIcon
                        showButtonBar
                        placeholder={t('form.monthYear')}
                        style={{ width: "100%" }}
                        view="month"
                        dateFormat="mm/yy"
                        value={monthYear}
                        onChange={handleMonthYearChange}
                    />
                </div>
            </div>

            {loading ? <Spinner /> : (

                <div className={classes.table_container}>
                    <DataTable
                        value={[...leaderboard]}
                        emptyMessage={t('common.noDataFound')}
                        showGridlines
                        responsive
                        scrollable
                        scrollDirection="both"
                        header={
                            <p className={classes.table_header}>
                                {t('leaderboard.title')}
                            </p>
                        }
                        scrollHeight="500px"
                    >
                        <Column
                            header={t('leaderboard.rank')}
                            body={(_, { rowIndex }) => rowIndex + 1}
                        />

                        <Column
                            field="msisdn"
                            header={t('common.msisdn')}
                        />
                        <Column
                            field="name"
                            header={t('common.name')}
                            body={(rowData) => {
                                if (rowData?.name) {
                                    return <p>{rowData?.name}</p>
                                }
                                else {
                                    return <p>{t('common.noName')}</p>
                                }
                            }
                            }
                        />
                        <Column
                            field="image"
                            header={t('common.image')}
                            body={(rowData) => {
                                if (rowData?.image) {
                                    return <img src={`${rowData?.image}`} alt="image"
                                        style={{ width: "48px", height: "48px", objectFit: "cover", borderRadius: "50%" }}
                                    />
                                }
                                else {
                                    return <p>{t('common.noImage')}</p>
                                }
                            }
                            }
                        />
                        <Column
                            field="total_points"
                            header={t('leaderboard.totalPoints')}
                        />
                        <Column
                            field="datetime"
                            header={t('common.dateTime')}
                            body={(rowData) =>
                                // moment(rowData?.datetime).format("DD-MM-YYYY HH:MM:SS") + " IST"
                                moment(rowData?.datetime)
                                    .tz("Africa/Kigali")
                                    .format("DD-MM-YYYY HH:mm:ss") + " CAT"
                            }
                        />
                    </DataTable>
                </div>
            )}

        </Layout>
    )
}

export default Leaderboard
